import { DomainEvent } from '../../../../../core/domain/events/domain_event';
import { MessageHelp } from '../../message-help';

export class MessageHelpEvent extends DomainEvent<MessageHelp> {}

export class MessageHelpCreated extends MessageHelpEvent {}

export class MessageHelpUpdated extends MessageHelpEvent {}

export class MessageHelpClosed extends MessageHelpEvent {}

export class MessageHelpOpened extends MessageHelpEvent {}
